// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldCake = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.9256 8.66699V9.33366H13.3456C12.8523 9.33366 12.4523 9.73366 12.4523 10.2337V10.4337C12.4523 10.9337 12.0523 11.3337 11.5523 11.3337C11.0589 11.3337 10.6589 10.9337 10.6589 10.4337V10.2337C10.6589 9.73366 10.2523 9.33366 9.75893 9.33366C9.2656 9.33366 8.8656 9.73366 8.8656 10.2337V10.4337C8.8656 10.9337 8.45893 11.3337 7.9656 11.3337C7.47227 11.3337 7.0656 10.9337 7.0656 10.4337V10.2337C7.0656 9.73366 6.6656 9.33366 6.17227 9.33366C5.67893 9.33366 5.27227 9.73366 5.27227 10.2337V10.4337C5.27227 10.9337 4.87227 11.3337 4.37893 11.3337C3.87893 11.3337 3.47893 10.9337 3.47893 10.4337V10.2203C3.47893 9.72699 3.0856 9.32699 2.59893 9.32033H2.07227V8.66699C2.07227 7.74699 2.7656 6.96699 3.7056 6.74033C3.89227 6.69366 4.0856 6.66699 4.29227 6.66699H11.7056C11.9123 6.66699 12.1056 6.69366 12.2923 6.74033C13.2323 6.96699 13.9256 7.74699 13.9256 8.66699Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.2937 4.77967V5.71967C12.1004 5.67967 11.907 5.66634 11.707 5.66634H4.2937C4.0937 5.66634 3.90036 5.68634 3.70703 5.72634V4.77967C3.70703 3.97967 4.42703 3.33301 5.32036 3.33301H10.6804C11.5737 3.33301 12.2937 3.97967 12.2937 4.77967Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.83398 2.36693V3.34026H5.32065C5.14732 3.34026 4.98732 3.36026 4.83398 3.40026V2.36693C4.83398 2.13359 5.06065 1.93359 5.33398 1.93359C5.60732 1.93359 5.83398 2.13359 5.83398 2.36693Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.166 2.21973V3.39973C11.0127 3.35306 10.8527 3.33306 10.6793 3.33306H10.166V2.21973C10.166 1.94639 10.3927 1.71973 10.666 1.71973C10.9393 1.71973 11.166 1.94639 11.166 2.21973Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.5 1.87967V3.33301H7.5V1.87967C7.5 1.57967 7.72667 1.33301 8 1.33301C8.27333 1.33301 8.5 1.57967 8.5 1.87967Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.6673 14.167C14.6673 14.4403 14.4407 14.667 14.1673 14.667H1.83398C1.56065 14.667 1.33398 14.4403 1.33398 14.167C1.33398 13.8936 1.56065 13.667 1.83398 13.667H2.07398V10.3203H2.48065V10.367C2.48065 11.2603 3.06732 12.087 3.94065 12.2803C4.62065 12.4403 5.26732 12.2203 5.70732 11.787C5.96065 11.5336 6.37398 11.527 6.62732 11.7803C6.97398 12.1203 7.44732 12.3336 7.96732 12.3336C8.48732 12.3336 8.96065 12.127 9.30732 11.7803C9.56065 11.5336 9.96732 11.5336 10.2273 11.787C10.6607 12.2203 11.3073 12.4403 11.994 12.2803C12.8673 12.087 13.454 11.2603 13.454 10.367V10.3336H13.9273V13.667H14.1673C14.4407 13.667 14.6673 13.8936 14.6673 14.167Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldCake };
